import { sm4, sm3 } from 'sm-crypto'
// ============ 加密/签名配置 ============
const APP_ID = '95cd0a80ee047ec07e981614e48e7540'
const APP_KEY_HEX = '96ea835d6343b42d936d2ac5d50e2693'

/**
 * SM4 加密（ECB，输出 hex），等价 Hutool encryptHex
 */
export const encrypt = (body) => {
  const plain = typeof body === 'string' ? body : JSON.stringify(body)
  // 直接传 APP_KEY_HEX 即可，sm-crypto 内部会正确解析
  return sm4.encrypt(plain, APP_KEY_HEX, { mode: 'ecb', output: 'string' })
}
/**
 * 生成 nonce（UUID，去掉横线，32 位）
 */
export const genNonce = () => {
  // 优先用 crypto.randomUUID，降级手写 v4
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '')
  }
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * SM3 签名：sm3(appid + nonce + encryptStr + appkey)，输出 hex
 * 与 Java: SmUtil.sm3(appid + nonce + encryptStr + appkey) 一致
 */
export const sign = (nonce, encryptStr) => {
  const raw = APP_ID + nonce + encryptStr + APP_KEY_HEX
  return sm3(raw) // 默认输出 hex 小写
}